<template>
  <!--单条资讯-->
  <card
    :width="100"
    :height="50"
    style="border-bottom: 1px solid #f5f5f5"
  >
    <tk-flex middle class="font-bold">
      <div class="article-top" v-if="articleSingle.isTop">置顶</div>
      <div class="van-ellipsis">{{articleSingle.articleTitle}}</div>
    </tk-flex>
    <template
      v-if="getArticleImage(articleSingle.IntroductionEvent).length === 1"
    >
        <tk-flex
          @click.native.stop="viewImages(postsImage, articleSingle.IntroductionEvent)"
          v-for="(postsImage, index) in getArticleImage(articleSingle.IntroductionEvent)"
          :key="`postsImage${index}`"
          class="full-width m-t-10 full-height"
        >
          <tk-image :src="postsImage" size="contain" oraign :quality="100" style="width: 100%;height: 100%;" height="98"></tk-image>
        </tk-flex>
    </template>
    <tk-flex
      v-if="getArticleImage(articleSingle.IntroductionEvent).length > 1"
      class="m-t-10"
      gutter="5"
    >
      <div
        class="content-box-image font-13"
        @click.stop="viewImages(s, articleSingle.IntroductionEvent)"
        v-for="(s, index) in getArticleImage(articleSingle.IntroductionEvent)"
        :key="index"
        :style="`background-image: url(${s}) !important`"
      >
      </div>
    </tk-flex>
    <tk-flex
      bottom
      between
      class="m-t-10 caption"
    >
      <div>{{articleSingle.createdAt | datetime}}</div>
      <tk-flex>
        <div>{{readSum | transform}}阅读</div>
        <div class="m-l-15">{{reviewsSum | transform}}评论</div>
      </tk-flex>
    </tk-flex>
    <!--查看大图组件-->
    <view-big-image
      ref="articleSingle"
      :watch-num="watchNum"
      v-if="articleSingle && getArticleImage(articleSingle.IntroductionEvent)"
      :commodity-image="getArticleImage(articleSingle.IntroductionEvent)"
    ></view-big-image>
  </card>

</template>

<script>
import viewBigImage from '@/components/viewBigImage'
export default {
  components: {
    viewBigImage
  },
  data () {
    return {
      watchNum: 0
    }
  },
  props: {
    articleSingle: {
      type: Object,
      required: true
    },
    articleIndex: {
      type: Number,
      required: true
    }
  },
  computed: {
    readSum () {
      return !this.articleSingle.readingSum ? 0 : this.articleSingle.readingSum
    },
    reviewsSum () {
      return !this.articleSingle.reviewsPostsList ? 0 : this.articleSingle.reviewsPostsList.length
    }
  },
  methods: {
    /**
     * 获取html中的图片
     * @date: 2020/3/23
     */
    getArticleImage (str) {
      let list = []
      str.replace(/<img [^>]*src=['"]([^'"]+)[^>]*>/g,
        function (
          match,
          capture
        ) {
          list.push(capture)
        })
      if (!list.length) { return [] }
      return list.splice(0, 3)
    },
    /**
     * 查看大图
     * @date: 2020/5/25
     */
    async viewImages (e, html) {
      let listImage = this.getArticleImage(html)
      this.watchNum = listImage.findIndex(s => { return s === e })
      await this.$tkHelper.sleep(10)
      this.$refs.articleSingle.showImages()
    }
  }
}
</script>

<style lang="scss" scoped>
  /*置顶样式*/
  .article-top {
    display: inline-block;
    min-width: 28px;
    height: 16px;
    text-align: center;
    line-height: 16px;
    background: rgba(247, 223, 223, 1);
    border-radius: 2px;
    font-size: 11px;
    color: rgba(207, 22, 19, 0.9);
    margin-right: 2px;
  }
  /*图片样式*/
  .content-box-image {
    height: 83px;
    overflow: hidden;
    width: 33%;
    background-repeat: no-repeat;
    -moz-background-size: cover;
    background-size: cover;
    background-position: center;
    /*border-radius: 5px;*/
  }
</style>
